import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopNav } from './TopNav';
import { User, Notification } from '../types';
interface AppShellProps {
  children: React.ReactNode;
  activePage: string;
  onNavigate: (page: string) => void;
  onLogout: () => void;
  user: User;
  notificationCount?: number;
  notifications?: Notification[];
}
export function AppShell({
  children,
  activePage,
  onNavigate,
  onLogout,
  user,
  notificationCount = 0,
  notifications = []
}: AppShellProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);
  const getPageTitle = () => {
    switch (activePage) {
      case 'dashboard':
        return 'Dashboard Monitoring';
      case 'activities':
        return 'Daftar Kegiatan Operasional';
      case 'activity-detail':
        return 'Detail Kegiatan';
      case 'activity-form':
        return 'Form Kegiatan';
      case 'progress':
        return 'Update Progres';
      case 'documents':
        return 'Dokumentasi Kegiatan';
      case 'verification':
        return 'Verifikasi Progres';
      case 'reports':
        return 'Laporan Kegiatan';
      case 'pro':
        return 'Operasi Amplifikasi (PRO)';
      case 'kontra':
        return 'Operasi Kontra-Narasi (KONTRA)';
      case 'osint':
        return 'Open Source Intelligence (OSINT)';
      case 'users':
        return 'Manajemen User';
      case 'audit-log':
        return 'Audit Log Sistem';
      default:
        return 'ROSS';
    }
  };
  return <div className="min-h-screen bg-[#0B0F1A] flex font-sans text-[#E2E8F0]" data-id="element-21">
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && <div className="fixed inset-0 bg-[#0B0F1A]/80 backdrop-blur-sm z-30 lg:hidden" onClick={closeSidebar} data-id="element-22"></div>}

      <Sidebar activePage={activePage} onNavigate={page => {
      onNavigate(page);
      closeSidebar();
    }} isOpen={sidebarOpen} onClose={closeSidebar} data-id="element-23" />

      <div className="flex-1 lg:ml-64 flex flex-col min-h-screen relative w-full" data-id="element-24">
        <TopNav pageTitle={getPageTitle()} user={user} notificationCount={notificationCount} notifications={notifications} onLogout={onLogout} onToggleSidebar={toggleSidebar} data-id="element-25" />

        <main className="flex-1 p-4 sm:p-6 overflow-y-auto relative" data-id="element-26">
          <div className="absolute inset-0 cyber-grid opacity-10 pointer-events-none z-0" data-id="element-27"></div>
          <div className="relative z-10" data-id="element-28">{children}</div>
        </main>
      </div>
    </div>;
}